module.exports = __webpack_public_path__ + "static/media/TEMPLATE7.d1a5556b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE7.jpg
// module id = 1473
// module chunks = 1